import React from 'react'
import Sticky from 'react-stickynode'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import useWindowSize from '../../hooks/useWindowSize'
import './queue.pcss'

export default function Queue({ count, reload, onUnqueueItems, isTagView }) {
  const { width } = useWindowSize()
  const sticky = width < 645

  const handleClick = () => {
    onUnqueueItems()
    if (sticky) {
      window.scroll({ top: 0, behavior: 'smooth' })
    }
  }

  let text = null
  if (reload === true) {
    text = 'Uusimmat'
  } else if (count > 1) {
    text = `${count} uutta juttua`
  } else if (count === 1) {
    text = '1 uusi juttu'
  }

  return (
    !isTagView ? (
      <Sticky
        className='items-queue'
        top={ 58 }
        bottomBoundary='#sticky-ad-bottom-boundary'
        innerZ={ 1 }
        enabled={ sticky }
      >
        { text ? (
          <div className='items-queue__content items-queue__content_new-items'>
            <button type='button' className='items-queue__button' onClick={ handleClick }>
              <span className='fa fa-chevron-up items-queue__content-arrow' />
              { text }
            </button>
          </div>
        ) : (
          <div className='items-queue__content items-queue__content_empty' />
        ) }
      </Sticky> )
      : (
        <div className='items-refresh'>
          <div className='items-queue__content items-queue__content_new-items'>
            <button type='button' className='items-queue__button' onClick={ handleClick }>
              <span className='fa fa-refresh items-queue__content-arrow' />
              Päivitä lista
            </button>
          </div>
        </div>
      )
  )
}

Queue.propTypes = exact({
  count: PropTypes.number,
  reload: PropTypes.bool.isRequired,
  onUnqueueItems: PropTypes.func.isRequired,
  isTagView: PropTypes.bool.isRequired,
})
